document.addEventListener('DOMContentLoaded', function() {
  // Getting all search forms on the page
  const searchForms = document.querySelectorAll('form.search-form');
  
  // Configuration options - these could be moved to theme settings
  const searchConfig = {
    // Search fields to include
    searchFields: 'title,product_type,vendor,variants.sku,variants.title',
    // search in product body text
    searchInProductBody: true,
    //  in product tags
    searchInProductTags: true,
    // How to handle unavailable products: 'show', 'hide', or 'last'
    unavailableProducts: 'last',
    // Cache duration in minutes
    cacheDuration: 30
  };
  
  // Adding body and tag fields if enabled
  if (searchConfig.searchInProductBody) {
    searchConfig.searchFields += ',body';
  }
  if (searchConfig.searchInProductTags) {
    searchConfig.searchFields += ',tag';
  }
  
  // Caching for search results
  const searchCache = {};
  
  // Function to clear expired cache entries
  function clearExpiredCache() {
    const now = new Date().getTime();
    Object.keys(searchCache).forEach(key => {
      if (now > searchCache[key].expiry) {
        delete searchCache[key];
      }
    });
  }
  
  // Clear expired cache entries on load
  clearExpiredCache();
  
  // Set up cache clearing interval (every 5 minutes)
  setInterval(clearExpiredCache, 5 * 60 * 1000);
  
  // Sfunction to clear all search inputs
  function clearAllSearchInputs(exceptInput = null) {
    // Targeting only the most common search inputs to improve performance
    const searchInputs = document.querySelectorAll('input[name="q"], header input[type="search"]');
    
    searchInputs.forEach(input => {
      if (input !== exceptInput) {
        input.value = '';
        try {
          input.dispatchEvent(new Event('input', { bubbles: true }));
        } catch (e) {}
        
        // Hide any associated search results
        const form = input.closest('form');
        if (form) {
          const resultsContainer = document.querySelector('.predictive-search-results');
          if (resultsContainer) {
            resultsContainer.style.display = 'none';
          }
        }
      }
    });
    
    // Directly target header search if it exists 
    const headerSearch = document.querySelector('header .search-form input[name="q"]');
    if (headerSearch && headerSearch !== exceptInput) {
      headerSearch.value = '';
      
      // Hide header search results if they exist
      const headerForm = headerSearch.closest('form');
      if (headerForm) {
        const headerResults = headerForm.parentNode.querySelector('.predictive-search-results');
        if (headerResults) {
          headerResults.style.display = 'none';
        }
      }
    }
    
    // Hide all predictive search results containers
    document.querySelectorAll('.predictive-search-results').forEach(container => {
      container.style.display = 'none';
    });
  }
  
  // Clears all search inputs when page loads - but only once
  clearAllSearchInputs();
  
  //  global function that can be called from anywhere
  window.clearAllSearches = clearAllSearchInputs;
  
  // Process each search form on the page
  searchForms.forEach(form => {
    const searchInput = form.querySelector('input[name="q"]');
    if (!searchInput) return; // Skip if no search input found
    
    // Creating the predictive search wrapper if it doesn't exist
    let resultsWrapper = form.parentNode.querySelector('.predictive-search-wrapper');
    if (!resultsWrapper) {
      resultsWrapper = document.createElement('div');
      resultsWrapper.className = 'predictive-search-wrapper';
      resultsWrapper.setAttribute('data-predictive-search', '');
      form.parentNode.appendChild(resultsWrapper);
    }
    
    // Create the results container if it doesn't exist
    let resultsContainer = resultsWrapper.querySelector('.predictive-search-results');
    if (!resultsContainer) {
      resultsContainer = document.createElement('div');
      resultsContainer.className = 'predictive-search-results';
      resultsContainer.setAttribute('data-predictive-search-results', '');
      resultsContainer.style.display = 'none';
      resultsWrapper.appendChild(resultsContainer);
    }
    
    //  CSS for the clear button positioning
    const styleElement = document.createElement('style');
    styleElement.textContent = `
      /* Clear button styling for Nood theme */
      .search-form {
        position: relative !important;
      }
      
      .search-clear-button {
        position: absolute !important;
        right: 70px !important;
        top: 50% !important;
        transform: translateY(-50%) !important;
        background-color: transparent !important;
        border: none !important;
        width: 24px !important;
        height: 24px !important;
        padding: 0 !important;
        margin: 0 !important;
        display: none !important;
        align-items: center !important;
        justify-content: center !important;
        cursor: pointer !important;
        z-index: 100 !important;
        opacity: 0.7 !important;
        transition: opacity 0.2s !important;
      }
      
      .search-clear-button:hover {
        opacity: 1 !important;
        background-color: rgba(0,0,0,0.05) !important;
      }
      
      .search-clear-button svg {
        width: 16px !important;
        height: 16px !important;
        color: #666 !important;
      }
      
      /* Specific adjustments for the Nood theme's inline mini form */
      .inline-mini-form .search-clear-button {
        right: 70px !important;
      }
      
      /* Make sure the button is visible only when needed */
      .search-clear-button.visible {
        display: flex !important;
      }
    `;
    document.head.appendChild(styleElement);
    
    // Function to position the results container
    function positionResults() {
      // Get the position of the search input
      const inputRect = searchInput.getBoundingClientRect();
      const formRect = form.getBoundingClientRect();
      
      // Position the results container below the search input
      resultsContainer.style.width = formRect.width + 'px';
      
      // For the modal search
      if (form.closest('#search-modal')) {
        resultsContainer.style.top = (formRect.height + 10) + 'px';
        resultsContainer.style.left = '0';
      } else if (form.closest('.site-header')) {
        // For header search
        resultsContainer.style.top = formRect.height + 'px';
        resultsContainer.style.left = 'auto';
        resultsContainer.style.right = '0';
      } else {
        // For other search forms (like search page)
        resultsContainer.style.top = formRect.height + 'px';
        resultsContainer.style.left = '0';
      }
    }
    
    // Function to generate search suggestions from API query results
    function generateSearchSuggestions(searchTerm, data) {
      const suggestions = [];
      
      // Always include the original term
      suggestions.push(searchTerm);
      
      // Extract query suggestions from the API response
      if (data && data.resources && data.resources.results && data.resources.results.queries) {
        const queries = data.resources.results.queries;
        
        // Add each query suggestion (up to 4)
        queries.forEach(query => {
          if (query.text && query.text.toLowerCase() !== searchTerm.toLowerCase()) {
            suggestions.push(query.text);
          }
        });
      }
      
      // Remove duplicates and limit to 5 suggestions
      return [...new Set(suggestions)].slice(0, 5);
    }
    
    // Function to fetch search results with caching
    function fetchSearchResults(searchTerm) {
      // Build the API URL - include both product and query resources
      const url = `/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product,query&resources[options][fields]=${searchConfig.searchFields}`;
      
      // Check if we have a cached result
      const cacheKey = `search_${searchTerm}`;
      if (searchCache[cacheKey] && searchCache[cacheKey].expiry > new Date().getTime()) {
        return Promise.resolve(searchCache[cacheKey].data);
      }
      
      // Fetch from the API
      return fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Search request failed: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          // Cache the result
          const expiryTime = new Date().getTime() + (searchConfig.cacheDuration * 60 * 1000);
          searchCache[cacheKey] = {
            data: data,
            expiry: expiryTime
          };
          
          return data;
        });
    }
    
    // Tracking the previous search term to detect backspacing
    let previousSearchTerm = '';
    let debounceTimer;
    
    // Show search results when input is focused (if there's a value)
    searchInput.addEventListener('focus', function() {
      if (this.value.trim().length > 0) {
        positionResults();
        // Trigger the input event to show results
        this.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
    
    // Add event listener for input changes
    searchInput.addEventListener('input', function() {
      const searchTerm = this.value.trim();
      
      // Clear previous timer
      clearTimeout(debounceTimer);
      
      // If input is empty, hide results
      if (searchTerm.length < 1) {
        resultsContainer.style.display = 'none';
        return;
      }
      
      // Debounce the search to prevent too many requests
      debounceTimer = setTimeout(() => {
        // Update position before showing results
        positionResults();
        
        // Fetch search suggestions with caching
        fetchSearchResults(searchTerm)
          .then(data => {
            // If the search term has changed while waiting for the response, ignore this result
            if (searchTerm !== searchInput.value.trim()) {
              return;
            }
            
            const products = data.resources.results.products;
            
            // Generate search term suggestions using the queries from the API response
            const termSuggestions = generateSearchSuggestions(searchTerm, data);
            
            // Start building the results HTML with search term suggestions
            let resultsHTML = `
              <div class="search-sections-container">
                <div class="search-section search-terms-section">
                  <h3 class="search-section-title">Suggested Searches</h3>
                  <ul class="search-suggestions-list">
            `;
            
            // Add each search term suggestion
            termSuggestions.forEach(term => {
              resultsHTML += `
                <li class="search-suggestion-item">
                  <button type="button" class="search-suggestion-button" data-search-term="${term}">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    ${term}
                  </button>
                </li>
              `;
            });
            
            // Close the search terms section
            resultsHTML += `
                </ul>
              </div>
            `;
            
            // Add product results section if there are products
            if (products.length > 0) {
              resultsHTML += `
                <div class="search-section search-products-section">
                  <h3 class="search-section-title">Products</h3>
                  <ul class="search-products-list">
            `;
              
              // Add each product
              products.forEach(product => {
                // Skip unavailable products if configured to hide them
                if (searchConfig.unavailableProducts === 'hide' && !product.available) {
                  return;
                }
                
                resultsHTML += `
                  <li class="search-product-item${!product.available ? ' product-unavailable' : ''}">
                    <a href="${product.url}">
                      ${product.image ? `<img src="${product.image}" alt="${product.title}">` : ''}
                      <div>
                        <div class="product-title">${product.title}</div>
                        <div class="product-price">${product.price}</div>
                        ${!product.available ? '<div class="product-unavailable-label">Sold Out</div>' : ''}
                      </div>
                    </a>
                  </li>
                `;
              });
              
              // Close the products section
              resultsHTML += `
                  </ul>
                </div>
              `;
            } else {
              // If no products, show a message
              resultsHTML += `
                <div class="search-section search-products-section">
                  <h3 class="search-section-title">Products</h3>
                  <div class="no-results-message">No products found</div>
                </div>
              `;
            }
            
            // Close the sections container
            resultsHTML += `</div>`;
            
            // Add "View all results" link
            resultsHTML += `
              <div class="view-all-results">
                <a href="/search?q=${encodeURIComponent(searchTerm)}&type=product">View all results</a>
              </div>
            `;
            
            // Update the results container
            resultsContainer.innerHTML = resultsHTML;
            
            // Only show results if the search term is still valid
            if (searchInput.value.trim().length >= 1) {
              resultsContainer.style.display = 'block';
            } else {
              resultsContainer.style.display = 'none';
            }
          })
          .catch(error => {
            console.error('Error fetching search suggestions:', error);
            resultsContainer.style.display = 'none';
          });
      }, 300); // 300ms debounce
    });
    
    // Created clear button for the search input with more visible styling
    const clearButton = document.createElement('button');
    clearButton.type = 'button';
    clearButton.className = 'search-clear-button';
    clearButton.setAttribute('aria-label', 'Clear search');
    clearButton.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    clearButton.style.display = 'none'; // Hide by default
    
    // Inserting the clear button directly into the search input's parent container
    searchInput.parentNode.appendChild(clearButton);
    
    // Function to toggle the clear button visibility
    function toggleClearButton() {
      const hasText = searchInput.value.trim().length > 0;
      if (hasText) {
        clearButton.classList.add('visible');
      } else {
        clearButton.classList.remove('visible');
      }
    }

    // Add input event listener to toggle clear button visibility
    searchInput.addEventListener('input', toggleClearButton);
    searchInput.addEventListener('change', toggleClearButton);
    searchInput.addEventListener('focus', toggleClearButton);

    // Hide clear button when search modal opens
    const searchModal = document.getElementById('search-modal');
    if (searchModal) {
      const modalToggle = document.querySelector('[data-modal-toggle="#search-modal"]');
      if (modalToggle) {
        modalToggle.addEventListener('click', () => {
          clearButton.classList.remove('visible');
          searchInput.value = ''; // Clear the input when modal opens
        });
      }
    }

    // Clear input and hide results when clear button is clicked
    clearButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Clear this input
      searchInput.value = '';
      searchInput.focus();
      toggleClearButton(); // This will hide the clear button
      
      // Hide results container
      resultsContainer.style.display = 'none';
      
      // Clear all other search inputs
      clearAllSearchInputs(searchInput);
      
      // Cancel any pending search requests
      clearTimeout(debounceTimer);
    });

    // Make sure clear button is hidden initially
    toggleClearButton();
    
    // Add event delegation for suggestion clicks
    resultsContainer.addEventListener('click', function(event) {
      const suggestionButton = event.target.closest('.search-suggestion-button');
      if (suggestionButton) {
        event.preventDefault();
        const term = suggestionButton.getAttribute('data-search-term');
        
        // Store a flag in localStorage to indicate we should clear the search after navigation
        localStorage.setItem('clearSearchAfterNavigation', 'true');
        
        // Navigate directly to the search results page for this term
        window.location.href = `/search?q=${encodeURIComponent(term)}&type=product`;
      }
      
      // Handle clicks on regular product links
      if (event.target.tagName === 'A' || event.target.closest('a')) {
        const link = event.target.tagName === 'A' ? event.target : event.target.closest('a');
        
        // For product links, prevent default and handle navigation
        event.preventDefault();
        
        // Don't navigate if it's a search suggestion button
        if (link.closest('.search-suggestion-button')) {
          return;
        }
        
        // Clear all search inputs before navigating
        clearAllSearchInputs();
        
        // Store a flag in localStorage to indicate we should clear the search after navigation
        localStorage.setItem('clearSearchAfterNavigation', 'true');
        
        window.location.href = link.href;
      }
    });
    
    // Hide results when clicking outside
    document.addEventListener('click', function(event) {
      if (!form.contains(event.target) && !resultsWrapper.contains(event.target)) {
        resultsContainer.style.display = 'none';
      }
    });
    
    // Also hide results when pressing Escape key
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        resultsContainer.style.display = 'none';
      }
    });
    
    // Clear search input when form is submitted
    form.addEventListener('submit', function(event) {
      // Prevent the default form submission
      event.preventDefault();
      
      // Get the search term
      const searchTerm = searchInput.value.trim();
      
      // Only proceed if there's a search term
      if (searchTerm.length > 0) {
        // Hide the results container
        resultsContainer.style.display = 'none';
        
        // Store a flag in localStorage to indicate we should clear the search after navigation
        localStorage.setItem('clearSearchAfterNavigation', 'true');
        
        // Navigate to the search results page
        window.location.href = `/search?q=${encodeURIComponent(searchTerm)}&type=product`;
      }
    });
  });
  
  // Check if we need to clear search inputs after navigation - only once per page load
  if (localStorage.getItem('clearSearchAfterNavigation') === 'true') {
    clearAllSearchInputs();
    localStorage.removeItem('clearSearchAfterNavigation');
  }
  
  // Simple script to clear search inputs on page load
  const clearScript = document.createElement('script');
  clearScript.textContent = `
    // Clear search inputs when page loads
    if (localStorage.getItem('clearSearchAfterNavigation') === 'true') {
      document.querySelectorAll('input[name="q"]').forEach(input => {
        input.value = '';
      });
      document.querySelectorAll('.predictive-search-results').forEach(container => {
        container.style.display = 'none';
      });
      localStorage.removeItem('clearSearchAfterNavigation');
    }
  `;
  document.head.appendChild(clearScript);
  
  // Add a function to clear the search after a selection
  function clearSearchAfterSelection() {
    // Clear all search inputs
    clearAllSearchInputs();
    
    // Hide all search results
    document.querySelectorAll('.predictive-search-results').forEach(container => {
      container.style.display = 'none';
    });
  }
  
  // Also clear search when clicking "View all results"
  document.addEventListener('click', function(event) {
    if (event.target.closest('.view-all-results a')) {
      // Clear the search after a short delay to allow the navigation to happen
      setTimeout(function() {
        localStorage.setItem('clearSearchAfterNavigation', 'true');
      }, 100);
    }
  });

  // Get the search modal and close button
  const searchModal = document.getElementById('search-modal');
  const closeButton = searchModal.querySelector('[data-modal-close]');
  
  // Function to clear search input and results
  function clearSearchOnClose() {
    // Clear all search inputs
    const searchInputs = document.querySelectorAll('.search-form input[type="text"], .search-form input[name="q"]');
    searchInputs.forEach(input => {
      input.value = '';
    });

    // Hide any visible search results
    const resultsContainers = document.querySelectorAll('.predictive-search-results');
    resultsContainers.forEach(container => {
      container.style.display = 'none';
    });
  }

  // Clear search when modal is closed via close button
  closeButton.addEventListener('click', clearSearchOnClose);

  // Clear search when modal is closed via escape key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && searchModal.classList.contains('reveal')) {
      clearSearchOnClose();
    }
  });

  // Clear search when clicking outside the modal
  searchModal.addEventListener('click', function(event) {
    if (event.target === searchModal) {
      clearSearchOnClose();
    }
  });
});

